'use strict';

/**
* sniff <br />
* 使用场景：查看运行环境，设备，系统等信息
* @property hysdk.sniff
* @category Base
* @type
*
* <table style="text-align:center">
*       <tr>
*           <th colspan="2">字段</th>
*           <th>类型</th>
*           <th>说明</th>
*       </tr>
*       <tr>
*           <td colspan="2">android</td>
*           <td>bool</td>
*           <td>是否是 android 系统</td>
*       </tr>
*       <tr>
*           <td colspan="2">appVersion</td>
*           <td>string / undefined</td>
*           <td>vid</td>
*       </tr>
*       <tr>
*           <td rowspan="6">browsers</td>
*           <td>alipay</td>
*           <td>string / bool</td>
*           <td>是否是支付宝，为版本号或 false</td>
*       </tr>
*       <tr>
*           <td>opera</td>
*           <td>string / bool</td>
*           <td>是否是 Opera 浏览器，为版本号或 false</td>
*       </tr>
*       <tr>
*           <td>qq</td>
*           <td>string / bool</td>
*           <td>当是使用 qq，微信或 qq 浏览器打开时，为版本号，否则为 false </td>
*       </tr>
*       <tr>
*           <td>uc</td>
*           <td>string / bool</td>
*           <td>是否是 UC 浏览器，为版本号或 false</td>
*       </tr>
*       <tr>
*           <td>wechat</td>
*           <td>string / bool</td>
*           <td>是否是微信，为版本号或 false</td>
*       </tr>
*       <tr>
*           <td>weibo</td>
*           <td>string / bool</td>
*           <td>是否是微博，为版本号或 false</td>
*       </tr>
*       <tr>
*           <td colspan="2">ctripApp</td>
*           <td>bool</td>
*           <td>是否是携程客户端</td>
*       </tr>
*       <tr>
*           <td colspan="2">ctripUseBase64</td>
*           <td>bool</td>
*           <td>是否是使用 base64 编码的 携程客户端</td>
*       </tr>
*       <tr>
*           <td colspan="2">hy</td>
*           <td>bool / undefined</td>
*           <td>运行环境是否是 hy，在 ready 后可获取</td>
*       </tr>
*       <tr>
*           <td colspan="2">imobile</td>
*           <td>bool / undefined</td>
*           <td>是否是 iphone / ipod</td>
*       </tr>
*       <tr>
*           <td colspan="2">info</td>
*           <td>object</td>
*           <td>useragent 详细信息</td>
*       </tr>
*       <tr>
*           <td colspan="2">ios</td>
*           <td>bool</td>
*           <td>是否是 iOS 系统</td>
*       </tr>
*       <tr>
*           <td colspan="2">ipad</td>
*           <td>bool</td>
*           <td>是否是 ipad</td>
*       </tr>
*       <tr>
*           <td colspan="2">iphone</td>
*           <td>bool</td>
*           <td>是否是 iphone</td>
*       </tr>
*       <tr>
*           <td colspan="2">ipod</td>
*           <td>bool</td>
*           <td>是否是 ipod</td>
*       </tr>
*       <tr>
*           <td colspan="2">os</td>
*           <td>string / undefined</td>
*           <td>设备系统，为 ios 或 android，pc 端为 undefined</td>
*       </tr>
*       <tr>
*           <td colspan="2">osVersion</td>
*           <td>string / undefined</td>
*           <td>系统详细版本号，pc 端为 undefined</td>
*       </tr>
*       <tr>
*           <td colspan="2">osVersionN</td>
*           <td>number / undefined</td>
*           <td>系统数字化，pc 端为 undefined</td>
*       </tr>
*       <tr>
*           <td colspan="2">pc</td>
*           <td>bool</td>
*           <td>是否是 pc 端</td>
*       </tr>
*       <tr>
*           <td colspan="2">pixelRatio</td>
*           <td>number</td>
*           <td>像素比</td>
*       </tr>
*       <tr>
*           <td colspan="2">qunar</td>
*           <td>bool</td>
*           <td>是否是 qunar 大客户端</td>
*       </tr>
*       <tr>
*           <td colspan="2">retina</td>
*           <td>bool</td>
*           <td>是否是 retina 屏</td>
*       </tr>
*       <tr>
*           <td colspan="2">scheme</td>
*           <td>string / undefined</td>
*           <td>scheme 协议，'qunariphone'，'qunaraphone'...</td>
*       </tr>
*       <tr>
*           <td colspan="2">webApp</td>
*           <td>bool</td>
*           <td>是否是 WebApp （在桌面上显示图标的 webapp）</td>
*       </tr>
*       <tr>
*           <td colspan="2">winos</td>
*           <td>bool</td>
*           <td>是否是 Windows Phone</td>
*       </tr>
*       <tr>
*           <td colspan="2">youthCtripApp</td>
*           <td>bool</td>
*           <td>是否是携程学生版客户端</td>
*       </tr>
* </table>
*
* @description
*
* | 运行环境 | 是否支持 |
* | :-----: | :-----: |
* | Hy      |   √   |
* | Hy Browser (qunar) | √    |
* | Hy Browser (非qunar) | √    |
* | touch   |   √   |
* | wechat  |   √   |
* | ctrip   |   √   |
*
*/
var ySniff = {
    browsers: {},
    info: {}
}; // 结果

var ua = navigator.userAgent,
    platform = navigator.platform,
    android = ua.match(/(Android);?[\s\/]+([\d.]+)?/),
    // 匹配 android
ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
    // 匹配 ipad
ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/),
    // 匹配 ipod
iphone = ua.match(/(iPhone\sOS)\s([\d_]+)/),
    // 匹配 iphone
webApp = ua.indexOf('Safari') === -1; // 匹配 桌面 webApp

var browsers = {
    wechat: ua.match(/(MicroMessenger)\/([\d\.]+)/), // 匹配 weChat
    alipay: ua.match(/(AlipayClient)\/([\d\.]+)/), // 匹配 支付宝
    qq: ua.match(/(MQQBrowser)\/([\d\.]+)/), // 匹配 QQ 浏览器
    weibo: ua.match(/(weibo__)([\d\.]+)/), // 匹配 微博
    uc: ua.match(/(UCBrower)\/([\d\.]+)/), // 匹配 uc
    opera: ua.match(/(Opera)\/([\d\.]+)/) // 匹配 opera
};

// 系统

ySniff.ios = ySniff.android = ySniff.iphone = ySniff.ipad = ySniff.ipod = false;

if (android) {
    ySniff.os = 'android';
    ySniff.osVersion = android[2];
    ySniff.android = true;
}

if (ipad || iphone || ipod) {
    ySniff.os = 'ios';
    ySniff.ios = true;
}

if (iphone) {
    ySniff.osVersion = iphone[2].replace(/_/g, '.');
    ySniff.iphone = true;
    ySniff.imobile = true;
}

if (ipad) {
    ySniff.osVersion = ipad[2].replace(/_/g, '.');
    ySniff.ipad = true;
}

if (ipod) {
    ySniff.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
    ySniff.ipod = true;
    ySniff.imobile = true;
}

// iOS 8+ changed UA
if (ySniff.ios && ySniff.osVersion && ua.indexOf('Version/') >= 0) {
    if (ySniff.osVersion.split('.')[0] === '10') {
        ySniff.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
    }
}

if (ySniff.osVersion) {
    ySniff.osVersionN = parseInt(ySniff.osVersion.match(/\d+\.?\d*/)[0]);
}

// 配置

ySniff.pixelRatio = window.devicePixelRatio || 1;

ySniff.retina = ySniff.pixelRatio >= 2;

// 浏览器
for (var key in browsers) {
    if (browsers[key]) {
        webApp = false;
        ySniff.browsers[key] = browsers[key][2];
    } else {
        ySniff.browsers[key] = false;
    }
}

ySniff.webApp = ySniff.os === 'ios' && webApp;

// 其他信息
ua.split(' ').forEach(function (item) {
    var kv = item.split('/');
    if (kv.length === 2) {
        ySniff.info[kv[0]] = kv[1];
    }
});

// PC
ySniff.pc = platform.indexOf('Mac') === 0 || platform.indexOf('Win') === 0 || platform.indexOf('linux') === 0 && !ySniff.android;

module.exports = ySniff;


//////////////////
// WEBPACK FOOTER
// ../src/lib/ySniff.js
// module id = 4
// module chunks = 0 2 4